import DeleteDevice from '../components/Actions/DeleteDevice'
import ChooseCategory from '../components/ChooseCategory'
import computedDevice from './computed/device'
import dataDevice from './data/device'
import methodsDevice from './methods/device'

export default {
  components: {
    ChooseCategory,
    DeleteDevice
  },
  data: dataDevice,
  computed: computedDevice,
  methods: methodsDevice
}
